import { render, staticRenderFns } from "./DashboardArticleLink.vue?vue&type=template&id=0f0d4075&scoped=true"
import script from "./DashboardArticleLink.vue?vue&type=script&lang=js"
export * from "./DashboardArticleLink.vue?vue&type=script&lang=js"
import style0 from "./DashboardArticleLink.vue?vue&type=style&index=0&id=0f0d4075&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0d4075",
  null
  
)

export default component.exports